import { getSubmitFormValues } from '@/components/react/form/lib/getFormFormatedValues';
import type {
  ContactFormValues,
  GatedContentFormValues,
  MetaValues,
} from '@/schemas/components/molecules/formSchema';
import type { AstroLocale } from '@/schemas/components/shared/i18n';

export const submitContactForm = async (
  value: ContactFormValues,
  meta: MetaValues,
  lang: AstroLocale,
  isChineseForm?: boolean,
) => {
  const formData = new FormData();
  const mutatedValues = getSubmitFormValues(value, meta, lang);

  for (const [key, val] of Object.entries(mutatedValues)) {
    formData.append(key, val as string);
  }

  if (window.dataLayer && !isChineseForm) {
    window.dataLayer.push({
      event: 'form_submit',
      eventTimeout: 2000,
    });
  }

  const url =
    isChineseForm ?
      import.meta.env.PUBLIC_CONTACT_CHINA_FORM_LAMBDA_URL
    : import.meta.env.PUBLIC_CONTACT_FORM_LAMBDA_URL;

  const response = await fetch(url, {
    method: 'POST',
    body: formData,
  });

  const message = await response.text();

  if (!response.ok) {
    window.posthog.captureException(new Error(message), {
      $exception_fingerprint: 'FormSubmissionError',
      $formData: {
        ...mutatedValues,
      },
    });

    return Promise.reject(message);
  }

  return message;
};

export const submitGatedContentForm = async (value: GatedContentFormValues) => {
  const response = await fetch(
    import.meta.env.PUBLIC_NEWSLETTER_URL
      || 'https://wwn7thac36gsrxwe2b6vyba2gm0mtsbx.lambda-url.us-east-1.on.aws/',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(value),
    },
  );

  const message = await response.text();

  if (!response.ok) {
    window.posthog.captureException(new Error(message), {
      $exception_fingerprint: 'GatedContentFormSubmissionError',
      $formData: {
        ...value,
      },
    });

    return Promise.reject(message);
  }

  return message;
};
